export const REVENUE_MANAGEMENT_ROOT_ENDPOINT = `revenue-management`;
export const RESERVATION_ROOT_ENDPOINT = 'reservation';
export const SETTINGS_ROOT_ENDPOINT = `settings`;
export const HOUSE_KEEPING_ROOT_ENDPOINT = `housekeeping`;
export const CASHIER_ROOT_ENDPOINT = `cash_register`;
export const REPORT_ENDPOINT = `report`;
